import { useMemo } from "react";
import { COMMON_WEB_PATH, DATA2_PATH } from "../constant";

const oneone = "oneone"; //the one機台
const vip911 = "911vip"; //911機台
const kimyu = "67vip"; //金宇

/**
 * @description 根據當前網域返回對應的配置
 * @param {string} domain - 當前網域
 * @param {string} webName - 網站名稱
 * @param {string} prefix - 網站前綴
 * @param {string} animationLogoUrl - 動畫 Logo URL
 * @param {string} mainLogoUrl - 主 Logo URL
 * @param {string} faviconUrl - 網站圖標 URL
 * @param {string} videoUrl - 長條影片 URL
 * @returns 當前網域的配置
 */

const siteConfig = {
  oneone: {
    webName: "the One",
    prefix: "oneone",
    host: "https://oneone.win",
    animationLogoUrl: `${COMMON_WEB_PATH}/911TW/Logo/one_logo.webp`,
    mainLogoUrl: `${COMMON_WEB_PATH}/911TW/Logo/one_logo.webp`,
    faviconUrl: `${COMMON_WEB_PATH}/911TW/Logo/one_logo.webp`,
    videoUrl: `${COMMON_WEB_PATH}/911TW/911_m_video.mp4`,
  },
  vip911: {
    webName: "911機台",
    prefix: "911vip",
    host: "https://911vip.tw",
    animationLogoUrl: `${COMMON_WEB_PATH}/911TW/Logo/logo_Animation.png`,
    mainLogoUrl: `${DATA2_PATH}/logo/menu_top_logo.png`,
    faviconUrl: `${DATA2_PATH}/logo/pwa_logo_144.png`,
    videoUrl: `${COMMON_WEB_PATH}/911TW/911_m_video.mp4`,
  },
  kimyu: {
    webName: "金宇機台",
    prefix: "kimyu",
    host: "https://67vip.co",
    animationLogoUrl: `${COMMON_WEB_PATH}/911TW/Logo/kimyu_logo.png`,
    mainLogoUrl: `${COMMON_WEB_PATH}/911TW/Logo/kimyu_logo.png`,
    faviconUrl: `${COMMON_WEB_PATH}/911TW/Logo/kimyu_logo.png`,
    videoUrl: `${COMMON_WEB_PATH}/911TW/kimyu_m_video_v2.mp4`,
  },
};

const useDomainConfig = () => {
  const domainConfig = useMemo(() => {
    const host = window.location.hostname;

    const isOneone = host.includes(oneone);
    const isVip911 = host.includes(vip911);
    const isKimyu = host.includes(kimyu);

    if (isOneone) {
      return siteConfig.oneone;
    } else if (isVip911) {
      return siteConfig.vip911;
    } else if (isKimyu) {
      return siteConfig.kimyu;
    } else {
      // 預設回傳 911vip 配置
      return siteConfig.vip911;
    }
  }, []);

  return domainConfig;
};

export default useDomainConfig;
